export const JOBS = "JOBS"
export const CAMPSITES_DATA_SYNC_JOB_TRIGGER = "CAMPSITES_DATA_SYNC_JOB_TRIGGER"
